module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/elegant-22f89f5b520d0aa59bebeb08a5914780.jpg";